export function hasBrowserSseSupport() {
  return !!window.EventSource;
}
